
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.879 0c-2.363.087-4.113.787-5.25 2.188-1.225 1.662-1.493 4.21-.793 7.273-.263.35-.52.94-.52 1.64.175 1.4.788 2.297 1.313 2.735.35 1.312 1.214 2.428 1.914 2.953v1.149l.355.164c.875.525 2.45 1.148 3.063 1.148.612 0 1.996-.602 2.871-1.04l.629-.355V16.898c.787-.612 1.57-1.75 1.832-3.062.525-.438 1.23-1.329 1.23-2.379 0-.7-.175-1.307-.437-1.832.35-1.225 1.132-4.627-.355-6.727-.438-.612-1.149-1.246-2.462-1.421C15.57.602 14.28 0 12.88 0zM9.023 19.523c-.612.438-1.575.766-2.625 1.204C3.686 21.777.263 23.012 0 27.125c0 .262.098.427.273.602.088.175.257.273.52.273h10.5v-.875c0-2.538 1.395-4.813 1.395-4.813l-.684-1.476c-1.138-.35-2.554-1.055-2.816-1.23l-.165-.083zm8.122 0l-.329.165c-.262.175-1.596.798-2.734 1.148l-.684 1.477s1.477 2.274 1.477 4.812V28h10.5a.839.839 0 00.629-.273.895.895 0 00.246-.602c-.35-4.113-3.768-5.436-6.48-6.398-1.05-.35-2.013-.766-2.625-1.204z","fill":"#FB6A01"}})])
          )
        }
      }
    